import React from 'react';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
} from 'recharts';

const hasValue = (arr = []) => arr.some((item) => Number(item?.value) > 0);

const NAMED_COLORS = {
  wallet: '#22c55e',
  aave: '#3b82f6',
  lido: '#14b8a6',
  belts: '#f59e0b',
  ethereum: '#4f46e5',
  arbitrum: '#ef4444',
};

const FALLBACK_PALETTE = [
  '#22c55e',
  '#3b82f6',
  '#14b8a6',
  '#f59e0b',
  '#ef4444',
  '#0ea5e9',
  '#84cc16',
  '#f97316',
  '#e11d48',
  '#10b981',
  '#2563eb',
  '#facc15',
];

function hashString(input) {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

function colorForName(name, index) {
  const key = String(name || '').toLowerCase();
  if (NAMED_COLORS[key]) return NAMED_COLORS[key];
  const seed = key ? hashString(key) : index;
  return FALLBACK_PALETTE[seed % FALLBACK_PALETTE.length];
}

export default function PortfolioCharts({ allocationData, chainData }) {
  return (
    <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
      <div className="card">
        <div className="muted small" style={{ marginBottom: '0.5rem' }}>Allocation by Bucket</div>
        <div style={{ width: '100%', height: 220 }}>
          {hasValue(allocationData) ? (
            <ResponsiveContainer>
              <PieChart>
                <Pie data={allocationData} dataKey="value" nameKey="name">
                  {allocationData.map((entry, index) => (
                    <Cell key={`alloc-${entry?.name || index}`} fill={colorForName(entry?.name, index)} />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => `$${Number(value).toLocaleString()}`} />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <div className="muted small">No priced allocation yet.</div>
          )}
        </div>
      </div>

      <div className="card">
        <div className="muted small" style={{ marginBottom: '0.5rem' }}>Chain Totals</div>
        <div style={{ width: '100%', height: 220 }}>
          {hasValue(chainData) ? (
            <ResponsiveContainer>
              <BarChart data={chainData}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip formatter={(value) => `$${Number(value).toLocaleString()}`} />
                <Bar dataKey="value">
                  {chainData.map((entry, index) => (
                    <Cell key={`chain-${entry?.name || index}`} fill={colorForName(entry?.name, index)} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="muted small">No priced chain totals yet.</div>
          )}
        </div>
      </div>
    </div>
  );
}
